import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Portfolio from "./pages/Portfolio";
import PortfolioCompany from "./pages/PortfolioCompany";
import Schedule from "./pages/Schedule";
import FAQ from "./pages/FAQ";
import Blog from "./pages/Blog";
import CaseStudies from "./pages/CaseStudies";
import EcosystemLedGrowth from "./pages/blog/EcosystemLedGrowth";
import ReduceCAC from "./pages/blog/ReduceCAC";
import XFactorModel from "./pages/blog/XFactorModel";
import HyperscalerAdvantages from "./pages/blog/HyperscalerAdvantages";
import SeedToScale from "./pages/blog/SeedToScale";
import Disclaimer from "./pages/Disclaimer";
import NotFound from "./pages/NotFound";
import CookieConsent from "./components/CookieConsent";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <CookieConsent />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/portfolio/:id" element={<PortfolioCompany />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/ecosystem-led-growth" element={<EcosystemLedGrowth />} />
          <Route path="/blog/reduce-cac" element={<ReduceCAC />} />
          <Route path="/blog/xfactor-model" element={<XFactorModel />} />
          <Route path="/blog/hyperscaler-advantages" element={<HyperscalerAdvantages />} />
          <Route path="/blog/seed-to-scale" element={<SeedToScale />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
